import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import ActiveTabContext from "./ActiveTabContext";
import { useNavigate } from "react-router-dom";
import Tabs from "./Tabs";
import Geo from "./geo";
import "./style.css";

const Header = ({ isSticky }) => {
  const { moveLineToTab } = useContext(ActiveTabContext);
  const navigate = useNavigate();
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark_theme"
  );
  const [themeBtnActive, setThemeBtnActive] = useState(theme === "light_theme");
  const location = useLocation();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useEffect(() => {
    let newActiveTabIndex = 0; // Default to Home

    // Prioritize hash-based routing for the Home page
    switch (location.hash) {
      case "#about":
        newActiveTabIndex = 1; // About
        break;
      case "#skills":
        newActiveTabIndex = 2; // Skills
        break;
      case "#contact":
        newActiveTabIndex = 4; // Contact
        break;
      default:
        // Path-based routing for other pages
        if (location.pathname.startsWith("/portfolio")) {
          newActiveTabIndex = 3; // Portfolio
        }
        break;
    }

    setActiveTabIndex(newActiveTabIndex);
  }, [location.pathname, location.hash]);

  const tabs = [
    {
      label: "Home",
      linkTo: "/",
      id: "home",
      onClick: () => {
        setActiveTabIndex(0);
        navigate("/");
        window.scrollTo(0, 0);
      },
    },
    { label: "About", linkTo: "/#about", id: "about" },
    { label: "Skills", linkTo: "/#skills", id: "skills" },
    { label: "Portfolio", linkTo: "/portfolio" },
    { label: "Contact", linkTo: "/#contact", id: "contact" },
  ];

  useEffect(() => {
    // Defer setting the active tab index
    setTimeout(() => {
      // Handle path-based links
      switch (location.pathname) {
        case "/portfolio_full":
          setActiveTabIndex(3); // Set to Portfolio tab
          break;
        // Add other cases if necessary
        default:
        // Do nothing for default case
      }

      // Handle hash-based links
      switch (location.hash) {
        case "#/":
        case "/": // If the home link is '/' without a hash
          setActiveTabIndex(0); // Set to Home tab
          break;
        case "#about":
          setActiveTabIndex(1); // Set to About tab
          break;
        case "#skills":
          setActiveTabIndex(2); // Set to Skills tab
          break;
        case "#contact":
          setActiveTabIndex(4); // Set to Contact tab
          break;
        default:
        // Do nothing for default case
      }
    }, 0); // Timeout set to 0 to defer execution until next event loop
  }, [location.pathname, location.hash]);

  const toggleTheme = () => {
    let newTheme = theme === "dark_theme" ? "light_theme" : "dark_theme";
    setTheme(newTheme);
    setThemeBtnActive(newTheme === "light_theme");
    document.body.className = newTheme;
    localStorage.setItem("theme", newTheme);
  };

  return (
    <header className={`header ${isSticky ? "active" : ""}`} data-header="">
      {location.pathname !== "/geo" && (
        <>
          <Geo isStandalone={false} />
        </>
      )}
      <div className="container">
        <h1 className="h1 logo">
          <Link to="/">
            <div className="gonzalogo">
              <img alt="Gonzalo Logo" src="/assets/images/gonzalogo.png" />
            </div>
            Gonza<span>.</span>
          </Link>
        </h1>

        <div className="navbar-actions">
          <select name="language" id="lang">
            <option value="en">En</option>
            <option value="ar">Ar</option>
          </select>

          <button
            className={`theme-btn ${themeBtnActive ? "active" : ""}`}
            aria-label="Change Theme"
            title="Change Theme"
            data-theme-btn
            onClick={toggleTheme}
          >
            <span className="icon"></span>
          </button>
        </div>

        <button
          className="nav-toggle-btn"
          aria-label="Toggle Menu"
          title="Toggle Menu"
          data-nav-toggle-btn
        >
          <span className="one"></span>
          <span className="two"></span>
          <span className="three"></span>
        </button>

        <nav className="navbar" data-navbar>
          <Tabs tabs={tabs} activeTab={activeTabIndex} />
        </nav>
      </div>
    </header>
  );
};

export default Header;
